/* RuthLuz — background add to cart.
   Without this file the product forms post natively, Shopify answers 302 and
   the whole page reloads. Here we post to /cart/add.js instead, ask Shopify to
   re-render the drawer and the header in the same request, then open the drawer. */
(function () {
  'use strict';

  var DRAWER_SECTION = 'ruthluz-cart-drawer';

  var panel = null;
  var scrim = null;
  var lastFocused = null;

  function qs(sel, scope) {
    return (scope || document).querySelector(sel);
  }

  function strings() {
    return (window.RuthLuzCart && window.RuthLuzCart.strings) || {};
  }

  /* The header lives in a section group, so its id is only knowable from the DOM. */
  function headerSectionId() {
    var el = document.querySelector('[id^="shopify-section-"][id$="__header_section"]');
    return el ? el.id.replace('shopify-section-', '') : null;
  }

  function sectionList() {
    return [DRAWER_SECTION, headerSectionId()].filter(Boolean).join(',');
  }

  /* ---------- open / close ---------- */

  function refs() {
    panel = qs('#RuthLuzCartDrawer');
    scrim = qs('[data-cart-drawer-root] .rl-drawer__scrim');
  }

  function open() {
    refs();
    if (!panel) return;
    lastFocused = document.activeElement;
    if (scrim) {
      scrim.hidden = false;
      requestAnimationFrame(function () {
        scrim.classList.add('is-open');
      });
    }
    panel.classList.add('is-open');
    panel.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    var close = qs('[data-cart-close]', panel);
    (close || panel).focus({ preventScroll: true });
  }

  function close() {
    if (!panel || !panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    if (scrim) {
      scrim.classList.remove('is-open');
      setTimeout(function () {
        scrim.hidden = true;
      }, 340);
    }
    document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus({ preventScroll: true });
  }

  function busy(state) {
    if (panel) panel.classList.toggle('is-busy', !!state);
  }

  function showError(message) {
    var box = qs('[data-cart-error]');
    if (box) box.textContent = message || '';
  }

  /* ---------- apply a section-rendering response ---------- */

  function applySections(sections) {
    if (!sections) return;

    var drawerHtml = sections[DRAWER_SECTION];
    if (drawerHtml) {
      var parsed = new DOMParser().parseFromString(drawerHtml, 'text/html');
      var freshBody = qs('[data-cart-contents]', parsed);
      var currentBody = qs('[data-cart-contents]');
      if (freshBody && currentBody) currentBody.innerHTML = freshBody.innerHTML;

      // the footer only exists while the cart has something in it
      var freshFoot = qs('[data-cart-foot]', parsed);
      var currentFoot = qs('[data-cart-foot]');
      if (freshFoot && currentFoot) currentFoot.innerHTML = freshFoot.innerHTML;
      else if (freshFoot && !currentFoot && currentBody) currentBody.insertAdjacentElement('afterend', freshFoot);
      else if (!freshFoot && currentFoot) currentFoot.remove();
    }

    var headerId = headerSectionId();
    if (headerId && sections[headerId]) {
      var target = document.getElementById('shopify-section-' + headerId);
      if (target) {
        var doc = new DOMParser().parseFromString(sections[headerId], 'text/html');
        var fresh = doc.getElementById('shopify-section-' + headerId) || doc.body.firstElementChild;
        if (fresh) target.innerHTML = fresh.innerHTML;
      }
    }
  }

  function post(url, payload) {
    payload.sections = sectionList();
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok) throw new Error(body.description || body.message || 'error');
        return body;
      });
    });
  }

  /* ---------- add to cart ---------- */

  function onSubmit(event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    event.preventDefault();
    showError('');

    var button = form.querySelector('[type="submit"]');
    if (button) button.setAttribute('aria-disabled', 'true');
    busy(true);

    var data = new FormData(form);
    data.append('sections', sectionList());

    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/javascript' }, body: data })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw new Error(body.description || body.message || 'error');
          return body;
        });
      })
      .then(function (body) {
        applySections(body.sections);
        open();
      })
      .catch(function (err) {
        showError(err.message || strings().error);
        open();
      })
      .finally(function () {
        busy(false);
        if (button) button.removeAttribute('aria-disabled');
      });
  }

  /* ---------- change quantity / remove ---------- */

  function changeLine(line, quantity) {
    showError('');
    busy(true);
    return post('/cart/change.js', { line: Number(line), quantity: Number(quantity) })
      .then(function (body) {
        applySections(body.sections);
      })
      .catch(function (err) {
        showError(err.message || strings().error);
      })
      .finally(function () {
        busy(false);
      });
  }

  /* ---------- delegated events ---------- */

  function onClick(event) {
    var t = event.target;

    if (t.closest('[data-cart-close]')) {
      event.preventDefault();
      close();
      return;
    }

    var openBtn = t.closest('a[href$="/cart"], a[href*="/cart?"]');
    if (openBtn && !t.closest('[data-cart-drawer-root]')) {
      event.preventDefault();
      refreshThenOpen();
      return;
    }

    var remove = t.closest('[data-cart-remove]');
    if (remove) {
      event.preventDefault();
      changeLine(remove.getAttribute('data-cart-line'), 0);
      return;
    }

    var step = t.closest('[data-cart-step]');
    if (step) {
      event.preventDefault();
      var line = step.getAttribute('data-cart-line');
      var input = document.querySelector('[data-cart-qty][data-cart-line="' + line + '"]');
      if (!input) return;
      var next = Math.max(0, Number(input.value || 0) + Number(step.getAttribute('data-cart-step')));
      changeLine(line, next);
    }
  }

  function onChange(event) {
    var input = event.target.closest('[data-cart-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-cart-line'), Math.max(0, Math.floor(Number(input.value) || 0)));
  }

  function refreshThenOpen() {
    busy(true);
    fetch('/?sections=' + encodeURIComponent(sectionList()), { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(applySections)
      .catch(function () {})
      .finally(function () {
        busy(false);
        open();
      });
  }

  document.addEventListener('submit', onSubmit);
  document.addEventListener('click', onClick);
  document.addEventListener('change', onChange);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refs);
  else refs();

  document.addEventListener('shopify:section:load', refs);

  window.RuthLuzCart = window.RuthLuzCart || {};
  window.RuthLuzCart.open = open;
  window.RuthLuzCart.close = close;
})();
